/**
 * ConfirmModal Component
 *
 * Simple confirmation dialog for destructive actions.
 *
 * @module containers/AdminMintingDapps/components/ConfirmModal
 * @category Admin
 */

import React from 'react';

/**
 * Props for ConfirmModal
 */
export interface ConfirmModalProps {
  /** Modal title */
  title: string;
  /** Confirmation message */
  message: string;
  /** Callback when user confirms */
  onConfirm: () => void;
  /** Callback when user cancels */
  onCancel: () => void;
  /** Text for confirm button */
  confirmText?: string;
  /** Variant for confirm button */
  confirmVariant?: 'primary' | 'danger' | 'warning';
}

/**
 * ConfirmModal - Reusable confirmation dialog.
 */
const ConfirmModal: React.FC<ConfirmModalProps> = ({
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  confirmVariant = 'primary',
}) => {
  return (
    <div className="modal show d-block" tabIndex={-1} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {confirmVariant === 'danger' && <i className="fas fa-exclamation-triangle text-danger me-2"></i>}
              {title}
            </h5>
            <button type="button" className="btn-close" onClick={onCancel}></button>
          </div>
          <div className="modal-body">
            <p>{message}</p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onCancel}>
              Cancel
            </button>
            <button
              type="button"
              className={`btn btn-${confirmVariant}`}
              onClick={() => {
                onConfirm();
              }}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
